export enum UserActivities {
  bulkUpdateNameMappings = "bulk_update_name_mappings",
  login = "login",
  logout = "logout",
  auto_logout = "auto_logout",
  offline = "offline",
  approvedPatientMatch = "approved_patient_match",
  rejectedPatientMatch = "rejected_patient_match",
  transitionCapture = "transition_capture",
  addCaptureDetails = "add_capture_details",
  reprocessCapture = "reprocess_capture",
  unverifyCapture = "unverify_capture",
  createAuditOutcome = "create_audit_outcome",
  setVerifyingPatientAttachmentCapture = "set_verifying_patient_attachment_capture",
  logInboundCall = "log_inbound_call",
  transitionFax = "transition_fax",
  addOfficeNote = "add_office_note",
  addProviderNote = "add_provider_note",
  addProviderOfficeNote = "add_provider_office_note",
  clearOfficeReviewStatus = "clear_office_review_status",
  createOffice = "create_office",
  editOfficeDetails = "edit_office_details",
  createProvider = "create_provider",
  editProviderDetails = "edit_provider_details",
  logOutboundCall = "log_outbound_call",
  clearProviderOfficeReviewStatus = "clear_provider_office_review_status",
  createProviderOfficeConnection = "create_provider_office_connection",
  editProviderOfficeDetails = "edit_provider_office_details",
  assignProviderReview = "assign_provider_review",
  assignmentConsultNote = "assignment_consult_note",
  submitConsultNote = "submit_consult_note",
  advancePatientPrescriber = "advance_patient_prescriber",
  submitClientConsultNoteTask = "submit_client_consult_note_task",
  submitClientReferralTask = "submit_client_referral_task",
  transitionClientPrescriberTask = "transition_client_prescriber_task",
}